(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initPanel(panel) {
    if (panel.dataset.ocInit === 'true') return;
    panel.dataset.ocInit = 'true';

    var cd = panel.querySelector('[data-oc-countdown]');
    var dateEls = panel.querySelectorAll('[data-oc-date]');

    // Cutoff hour (24h, store local) — order before this for "today"
    var cutoffHour = cd ? parseInt(cd.getAttribute('data-cutoff'), 10) : 14;
    if (isNaN(cutoffHour)) cutoffHour = 14;

    function nextCutoff() {
      var now = new Date();
      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
      if (now >= target) target.setDate(target.getDate() + 1);
      return target;
    }

    function tick() {
      if (!cd) return;
      var now = new Date();
      var target = nextCutoff();
      var diff = Math.max(0, target - now);
      var s = Math.floor(diff / 1000);
      var days = Math.floor(s / 86400); s -= days * 86400;
      var hours = Math.floor(s / 3600); s -= hours * 3600;
      var mins = Math.floor(s / 60); s -= mins * 60;
      var setEl = function (sel, val) { var e = cd.querySelector(sel); if (e) e.textContent = pad(val); };
      setEl('[data-days]', days);
      setEl('[data-hours]', hours);
      setEl('[data-mins]', mins);
      setEl('[data-secs]', s);
    }

    if (cd) { tick(); setInterval(tick, 1000); }

    // Delivery dates: base = today, + business days offset
    function addBusinessDays(start, n) {
      var d = new Date(start);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return d;
    }

    var fmt = { weekday: 'long', month: 'long', day: 'numeric' };
    dateEls.forEach(function (el) {
      var add = parseInt(el.getAttribute('data-add-days'), 10) || 0;
      var d = add > 0 ? addBusinessDays(new Date(), add) : new Date();
      try { el.textContent = d.toLocaleDateString(undefined, fmt); }
      catch (e) { el.textContent = d.toDateString(); }
    });
  }

  function boot() {
    document.querySelectorAll('.oc-panel').forEach(initPanel);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
